import {createMuiTheme} from '@mui/material/styles';
import {blue, green, red, yellow} from "@mui/material/colors";

/*
const theme = createMuiTheme({
    palette: {
        primary: {
            main: "#ffa300",
            light: "#ffd449",
            dark: "#c67400",
            contrastText: "#000000"
        },
        secondary: {
            main: "#ff8500",
            light: "#ffb644",
            dark: "#c55600",
            contrastText: "#000000"
        },
        error: {
            main: "#A21C2B"
        }
    }
});
 */
const theme = createMuiTheme({
    palette: {
        primary: {
            main: blue[900],
            light: blue[900],
            dark: blue[900],
            contrastText: blue[900],
        },
        secondary: {
            main: blue[700],
        },
        rosso: {
            backgroundColor: red[200],
            color: '#000'
        },
        verde: {
            backgroundColor: green[500],
            color: '#000',
        },
        giallo: {
            backgroundColor: yellow[500],
            color: '#000'
        },
        bianco: {
            color: '#FFFFFF'
        },
        bluchiaro: {
            backgroundColor: blue[200],
            color: '#000'
        },
    }
});

export default theme;
